import React from "react";
import * as Yup from "yup";
import { Formik } from "formik";
import { Form, Row, Col } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Label, Input, Button, InputGroup } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faCalendarAlt,
	faPaperclip,
	faWindowClose,
} from "@fortawesome/free-solid-svg-icons";
import { Config } from "../../../configurations/config";
import CustomReactSelect from "../../../components/CustomReactSelect";

const LeaveForm = ({
	id,
	formFields,
	handleSubmit,
	leaveStatus,
	disableEndDate,
	leavetypes,
	duration,
	leaveDuration,
	datehandleChange,
	handleChange,
	startdatehandleChange,
	openStartDatepicker,
	openEndDatepicker,
	startDatepickerRef,
	endDatepickerRef,
	attachedFileName,
	handleAddAttachement,
	fileErr,
	attachment,
	handleRemoveAttachement,
	AddHoursinTimesheet,
	handleDelete,
	handleReset,
	updateLeaveApplication,
	getDurationEndDate,
	onLeaveTypeChange,
}) => {
	const validate = Yup.object().shape({
		LeaveType: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		LeaveDuration: Yup.object().shape({
			label: Yup.string().required("Required"),
			value: Yup.string().required("Required"),
		}),
		LeaveReason: Yup.string()
			.required("Reason is Required")
			.max(500, "Max 500 characters allowed")
			.nullable(),
	});
	function getLeaveTypeClassName(leaveStatus, errors) {
		let leaveTypeClassName = "leavetype-dropdown";

		if (leaveStatus === "Approved") {
			leaveTypeClassName += " disbaled-class";
		} else if (errors.LeaveType) {
			leaveTypeClassName += " h-auto invalid";
		} else {
			leaveTypeClassName += " h-auto";
		}

		return leaveTypeClassName;
	}

	return (
		<Formik
			enableReinitialize={true}
			initialValues={formFields}
			validationSchema={validate}
			validateOnChange={true}
			onSubmit={handleSubmit}
		>
			{({ errors, handleSubmit }) => (
				<Form className="leave-form">
					<Label className="form-title" sm={12}>
						Leave Application
					</Label>
					<Form.Group as={Row} className="s-date">
						<Form.Label column lg={2} md={3} sm={5} xs={5}>
							Start Date <span className="required">*</span>
						</Form.Label>
						<Col>
							<InputGroup className="datepicker-wrapper">
								<DatePicker
									showYearDropdown
									showMonthDropdown
									dateFormatCalendar=" " //for title
									name="LeaveStartDate"
									className={`custom-container formValueInput${
										errors.LeaveStartDate
											? "h-auto invalid"
											: "h-auto"
									}`}
									selected={formFields.LeaveStartDate}
									onChange={startdatehandleChange}
									onChangeRaw={(e) => {
										e.preventDefault();
									}}
									autoComplete="off"
									dateFormat="dd/MM/yyyy"
									readOnly={
										leaveStatus === "Approved" ||
										leaveStatus === "Rejected"
									}
									ref={startDatepickerRef}
								/>
								<FontAwesomeIcon
									icon={faCalendarAlt}
									className="calender-icon"
									color="keppel"
									onClick={() => openStartDatepicker()}
								/>
							</InputGroup>
						</Col>
						<Form.Label className="pl-3">
							To <span className="required">*</span>
						</Form.Label>
						<Col>
							<InputGroup className="datepicker-wrapper">
								<DatePicker
									showYearDropdown
									showMonthDropdown
									dateFormatCalendar=" " //for title
									className={`formValueInput ${
										disableEndDate
											? "disabledCalenderPicker"
											: "custom-container"
									}`}
									selected={formFields.LeaveEndDate}
									onChange={datehandleChange}
									name="LeaveEndDate"
									minDate={formFields.LeaveStartDate}
									onChangeRaw={(e) => {
										e.preventDefault();
									}}
									readOnly={
										leaveStatus === "Approved" ||
										leaveStatus === "Rejected"
											? true
											: disableEndDate
									}
									autoComplete="off"
									dateFormat="dd/MM/yyyy"
									ref={endDatepickerRef}
								/>
								<FontAwesomeIcon
									icon={faCalendarAlt}
									className="calender-icon"
									color="keppel"
									onClick={() => openEndDatepicker()}
								/>
							</InputGroup>
						</Col>
					</Form.Group>

					<Form.Group
						as={Row}
						className="l-type"
						controlId="formPlaintextPassword"
					>
						<Form.Label column lg={2}>
							Leave Type <span className="required">*</span>
						</Form.Label>
						<Col lg={10}>
							<CustomReactSelect
								name="LeaveType"
								options={leavetypes}
								value={formFields.LeaveType}
								onChange={(value) => onLeaveTypeChange(value)}
								className={getLeaveTypeClassName(
									leaveStatus,
									errors
								)}
								isDisabled={
									leaveStatus === "Approved" ||
									leaveStatus === "Rejected"
								}
							/>
						</Col>
					</Form.Group>
					<Form.Group
						as={Row}
						className="leave-duration"
						controlId="formPlaintextPassword"
					>
						<Form.Label column lg={2}>
							Leave Duration <span className="required">*</span>
						</Form.Label>
						<Col lg={10}>
							<CustomReactSelect
								name="LeaveDuration"
								placeholder="Select"
								value={duration}
								options={leaveDuration}
								onChange={getDurationEndDate}
								className={`leavetype-dropdown ${
									errors.LeaveDuration
										? "h-auto invalid"
										: "h-auto"
								}`}
								isDisabled={
									leaveStatus === "Approved" ||
									leaveStatus === "Rejected"
								}
							/>
						</Col>
					</Form.Group>
					<Form.Group
						as={Row}
						className="l-Reason"
						controlId="formPlaintextPassword"
					>
						<Form.Label column lg={2}>
							Leave Reason <span className="required">*</span>
						</Form.Label>
						<Col lg={10}>
							<Form.Control
								type="text"
								name="LeaveReason"
								value={formFields.LeaveReason}
								onChange={handleChange}
								className={`formValueInput ${
									errors.LeaveReason
										? "h-auto invalid"
										: "h-auto"
								}`}
								readOnly={
									leaveStatus === "Approved" ||
									leaveStatus === "Rejected"
								}
							/>
							<Form.Control.Feedback type="invalid">
								Please Enter Leave Reason.
							</Form.Control.Feedback>
						</Col>
					</Form.Group>
					<Form.Group
						as={Row}
						className="comments"
						controlId="formPlaintextPassword"
					>
						<Form.Label column lg={2}>
							Comments
						</Form.Label>
						<Col lg={10}>
							<Form.Control
								type="text"
								name="EmployeeComments"
								value={
									formFields.EmployeeComments === "null"
										? null
										: formFields.EmployeeComments
								}
								onChange={handleChange}
								className={`formValueInput ${
									errors.EmployeeComments
										? "h-auto invalid"
										: "h-auto"
								}`}
								readOnly={
									leaveStatus === "Approved" ||
									leaveStatus === "Rejected"
								}
							/>
						</Col>
					</Form.Group>
					<Form.Group as={Row} className="l-attachment lastRow">
						<Label for="attachment" xs={12} sm={2}>
							Attachment
						</Label>
						<Col xs={10} sm={9} md={9} lg={9} id="attachment-align">
							{attachedFileName ? (
								<>
									<Input
										name="attachment"
										id="attachment"
										type="file"
										className="d-none"
										readOnly={true}
									/>
									<FontAwesomeIcon
										icon={faPaperclip}
										size="1x"
										color="black"
										className="attIcon"
									/>
									<a
										href={`${Config.server_url}/${attachedFileName}`}
										target="_blank"
										rel="noopener noreferrer"
										id="attLink"
										className="link"
									>
										{attachedFileName}
									</a>
									<span
										onClick={() =>
											document
												.getElementById("attachedFile")
												.click()
										}
									/>
								</>
							) : (
								<>
									<Input
										type="file"
										name="attachment"
										id="attachment"
										accept="image/png,image/jpeg,image/jpg,application/pdf,application/msword"
										onChange={(value) =>
											handleAddAttachement(value)
										}
										className="overflow-hidden"
										disabled={
											leaveStatus === "Approved" ||
											leaveStatus === "Rejected"
										}
										readOnly={
											leaveStatus !== "Approved" &&
											leaveStatus !== "Rejected"
										}
									/>
									{fileErr && (
										<div className="input-feedback">
											Only ".jpeg",".jpg",".png" type
											files allowed
										</div>
									)}
								</>
							)}
						</Col>
						<FontAwesomeIcon
							icon={faWindowClose}
							className="att-remove-icon"
							color="keppel"
							onClick={() => handleRemoveAttachement()}
							hidden={!attachment}
						/>
					</Form.Group>
					<div className="btns">
						{id && leaveStatus === "Approved" && (
							<>
								<Button
									className="mt-2 addHoursInTimeSheet"
									onClick={() => {
										AddHoursinTimesheet();
									}}
								>
									Add Hours in Timesheet
								</Button>
							</>
						)}

						{id ? (
							leaveStatus === "Pending" ? (
								<div className="mt-2">
									<Button
										className="delete-btn leftBtn"
										onClick={handleDelete}
									>
										Delete
									</Button>
									{/* <Button
										className="submit-btn leftBtn"
										onClick={() => {
											updateLeaveApplication();
										}}
									>
										Update
									</Button> */}
									<Button
										className="reset-btn"
										onClick={handleReset}
									>
										Reset
									</Button>
								</div>
							) : null
						) : (
							<>
								<input
									type="submit"
									className="submit-btn leftBtn"
									onClick={handleSubmit}
									value="Submit"
								/>
								<Button
									className="reset-btn"
									onClick={handleReset}
								>
									Reset
								</Button>
							</>
						)}
					</div>
				</Form>
			)}
		</Formik>
	);
};

export default LeaveForm;
